"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContentDesktop = void 0;
var _typography = require("@cian/ui-kit/typography");
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./styles.css"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ModalContentDesktop = props => {
  const {
    showHeader,
    children,
    footer
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['content'], showHeader && styles['offset'])
  }, showHeader && /*#__PURE__*/React.createElement("header", {
    className: styles['header']
  }, /*#__PURE__*/React.createElement(_typography.UIHeading2, null, "\u0414\u0430\u0442\u044B")), /*#__PURE__*/React.createElement("main", {
    className: styles['content']
  }, children), footer);
};
exports.ModalContentDesktop = ModalContentDesktop;